interface Tool {
  icon: string;
  signature: string;
  exampleLabel: string;
  desc: string;
  example: string;
}

const TOOLS: Tool[] = [
  {
    icon: '◑',
    signature: 'niche_saturation(niche)',
    exampleLabel: 'reviews-ugc',
    desc: 'Returns saturation + concentration + incumbent + rationale. Not a raw app dump.',
    example:
      '{ "saturation": 71, "label": "saturated",\n  "concentration": 0.21, "incumbent": "Judge.me",\n  "verdict": "Core is closed, opening is in new functions" }',
  },
  {
    icon: '▦',
    signature: 'function_map(niche)',
    exampleLabel: 'reviews-ugc',
    desc: 'A scored function matrix: each function with status Won/Contested/Open + coverage.',
    example:
      '[ { "function": "Q&A / Community",\n    "status": "open", "coverage": "2/10",\n    "best_quality": 58 }, … ]',
  },
  {
    icon: '◓',
    signature: 'opportunity_gaps(niche)',
    exampleLabel: 'reviews-ugc',
    desc: 'Functions worth building, ranked, with three parts demand / quality gap / monetization + evidence.',
    example:
      '[ { "function": "Q&A / Community",\n    "opportunity": 88, "demand": 84,\n    "quality_gap": 90, "monetization": 72 }, … ]',
  },
];

const CONNECT_SNIPPET =
  '{\n  "mcpServers": {\n    "scangap": {\n      "url": "https://mcp.scangap.com/sse",\n      "headers": { "Authorization": "Bearer sg_••••••••" }\n    }\n  }\n}';

export function Agent() {
  return (
    <div style={{ maxWidth: 880, margin: '0 auto', animation: 'nl-fade .3s ease' }}>
      <div style={{ textAlign: 'center', marginBottom: 30 }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            padding: '5px 12px',
            borderRadius: 20,
            background: '#eef0f2',
            color: '#303030',
            fontSize: 12,
            fontWeight: 700,
            fontFamily: "'JetBrains Mono'",
            marginBottom: 14,
          }}
        >
          {'{ }'} MCP Server
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 10px' }}>
          Access ScanGap via agents
        </h1>
        <p
          style={{
            margin: '0 auto',
            color: '#616161',
            fontSize: 15,
            maxWidth: 560,
            lineHeight: 1.55,
          }}
        >
          Agents call tools and get <b>computed conclusions + evidence</b> — not a raw data dump.
          That’s the difference from asking an LLM cold.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 26 }}>
        {TOOLS.map((t) => (
          <div
            key={t.signature}
            style={{
              background: '#fff',
              border: '1px solid #e1e3e5',
              borderRadius: 14,
              padding: 20,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 10,
                  background: '#eef0f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 18,
                  flexShrink: 0,
                }}
              >
                {t.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <code
                  style={{
                    fontFamily: "'JetBrains Mono'",
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#303030',
                  }}
                >
                  {t.signature}
                </code>
                <p
                  style={{ margin: '7px 0 12px', fontSize: 13, color: '#616161', lineHeight: 1.5 }}
                >
                  {t.desc}
                </p>
                <div
                  style={{
                    background: '#1f2a37',
                    borderRadius: 10,
                    padding: '13px 15px',
                    overflowX: 'auto',
                  }}
                >
                  <div
                    style={{
                      fontFamily: "'JetBrains Mono'",
                      fontSize: 11.5,
                      color: '#4a4f57',
                      marginBottom: 4,
                    }}
                  >
                    // {t.exampleLabel}
                  </div>
                  <div
                    style={{
                      fontFamily: "'JetBrains Mono'",
                      fontSize: 12,
                      color: '#dadcde',
                      whiteSpace: 'pre',
                      lineHeight: 1.5,
                    }}
                  >
                    {t.example}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{ background: '#fff', border: '1px solid #e1e3e5', borderRadius: 14, padding: 20 }}
      >
        <h2 style={{ fontSize: 15, fontWeight: 700, margin: '0 0 12px' }}>Connect</h2>
        <div style={{ background: '#1f2a37', borderRadius: 10, padding: 15, overflowX: 'auto' }}>
          <div
            style={{
              fontFamily: "'JetBrains Mono'",
              fontSize: 12,
              color: '#dadcde',
              whiteSpace: 'pre',
              lineHeight: 1.6,
            }}
          >
            {CONNECT_SNIPPET}
          </div>
        </div>
      </div>
    </div>
  );
}
